import { CSSProperties } from 'react';
import { defaultMemoize } from 'reselect';
import * as TypeStyle from 'typestyle';
import { getIconFromId, MenuItemCheckSvg } from '../components/Icons';

const DropdownMenuColors = {
  ContentColorNormal: '#666',
  ContentColorActive: '#333',
  ContentColorDisabled: '#BFBFBF',
  HeaderText: '#4F4F4F',
};

export const dropdownMenuStyles: CSSProperties = {
  boxShadow: '0 10px 16px -4px rgba(42, 87, 117, 0.2)',
  maxWidth: 316,
};

export const overflowDropdownStyleName = TypeStyle.style({
  $nest: {
    '.dropdown-arrow': {
      display: 'none',
    },
  },
});

export const MenuItemContainerStyleName = defaultMemoize((iconId: string | undefined, selected: boolean) =>
  TypeStyle.style({
    color: `${DropdownMenuColors.ContentColorNormal}`,
    cursor: 'pointer',
    padding: 8,
    $nest: {
      '&.highlighted': {
        backgroundColor: '#EBEBEB',
      },
      '&.active': {
        backgroundColor: '#CBCBCB',
        color: `${DropdownMenuColors.ContentColorActive}`,
      },
      '&.disabled': {
        color: `${DropdownMenuColors.ContentColorDisabled}`,
        cursor: 'default',
      },
      '.toolbar-dropdown-menu-item-checked': {
        backgroundImage: `url(${selected ? MenuItemCheckSvg(DropdownMenuColors.ContentColorNormal) : ''})`,
      },
      '&.active .toolbar-dropdown-menu-item-checked': {
        backgroundImage: `url(${selected ? MenuItemCheckSvg(DropdownMenuColors.ContentColorActive) : ''})`,
      },
      '&.disabled .toolbar-dropdown-menu-item-checked': {
        backgroundImage: `url(${selected ? MenuItemCheckSvg(DropdownMenuColors.ContentColorDisabled) : ''})`,
      },
      '.toolbar-dropdown-menu-item-icon': {
        backgroundImage: `url(${iconId ? getIconFromId(iconId)(DropdownMenuColors.ContentColorNormal) : ''})`,
      },
      '&.active .toolbar-dropdown-menu-item-icon': {
        backgroundImage: `url(${iconId ? getIconFromId(iconId)(DropdownMenuColors.ContentColorActive) : ''})`,
      },
      '&.disabled .toolbar-dropdown-menu-item-icon': {
        backgroundImage: `url(${iconId ? getIconFromId(iconId)(DropdownMenuColors.ContentColorDisabled) : ''})`,
      },
    },
  })
);

export const MenuItemStyleName = TypeStyle.style({
  display: 'flex',
});

export const MenuItemPrecedingIconStyleName = TypeStyle.style({
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '14px 14px',
  display: 'inline-block',
  height: 14,
  width: 14,
  marginRight: 4,
});

export const MenuItemLabelStyleName = TypeStyle.style({
  cursor: 'inherit', // overwrite default label element style
  fontSize: 12,
  userSelect: 'none',
  whiteSpace: 'nowrap',
  $nest: {
    '&.bold': {
      fontWeight: 'bold',
    },
  },
});

export const MenuItemDescriptionStyleName = TypeStyle.style({
  fontSize: 12,
  letterSpacing: 0.2,
  lineHeight: '18px', // 1.5 * fontSize
  marginTop: 8,
  maxWidth: 286,
  userSelect: 'none',
  width: 'max-content',
});

export const MenuItemHeaderStyleName = TypeStyle.style({
  color: `${DropdownMenuColors.HeaderText}`,
  fontWeight: 'bold',
  letterSpacing: 0.2,
  lineHeight: '12px',
  padding: '8px 4px',
});
